import { render } from "./InfoSidebar.vue?vue&type=template&id=65e9df8e&scoped=true"
import script from "./InfoSidebar.vue?vue&type=script&lang=js"
export * from "./InfoSidebar.vue?vue&type=script&lang=js"

import "./InfoSidebar.vue?vue&type=style&index=0&id=65e9df8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e9df8e"]])

export default __exports__